import React, {Component, PropTypes} from "react";
import {inject, observer} from 'mobx-react';
import * as mobx from 'mobx';
import {toJS} from 'mobx'
import {Tree, Button, Modal, Spin, message} from "antd";
import {WeaRightMenu, WeaPopoverHrm, WeaScroll, WeaDialog, WeaTree,WeaLocaleProvider} from "ecCom";
const getLabel = WeaLocaleProvider.getLabel
const TreeNode = Tree.TreeNode;
require('../../style/tree.less')
@observer
export default class FavouriteBrowser extends Component {
    /**
     * 树节点加载
     * @param treeNode
     */
    constructor(props){
        super(props)
    }


    /**
     * 树节点选中
     * @param key
     * @param evt
     */
    onSelect = (key, evt) => {
        let {favouriteBrowserStore} = this.props;
        let dirId = "0";   //默认是根目录
        if (key.length > 0) {
            dirId = key[0];
        }

        if (dirId.indexOf("add") == -1 && dirId.indexOf("edit") == -1) {    //非编辑状态下
            /**
             * 记录下选中的节点
             */
            favouriteBrowserStore.selectTreeNode(dirId);
        }
    }

    /**
     * 保存目录 
     * @param evt
     */
    saveFavourite = evt => {
        let {favouriteBrowserStore} = this.props;
        let {selectedKey} = favouriteBrowserStore;
        for (let key in this.refs) {
            let inputObj = this.refs[key];
            let value = inputObj.value;
            if (!value) {   //值为空
                Modal.error({content: `${getLabel(388203, "目录名称不能为空！")}`});
                inputObj.focus();
            } else {
                let parentid = selectedKey;
                let favname = value;
                let favdesc = "";
                let favorder = 0;
                favouriteBrowserStore.saveTreeNode({parentid, favname, favdesc, favorder});
            }
            break;
        }
    }

    /**
     * 编辑框的回车事件处理
     * @param evt
     */
    handleOnKeyDown = evt => {
        let keyCode = evt.keyCode;
        if (keyCode == 13) {  //enter key
            this.saveFavourite(evt);
        }
    }

    /**
     * 关闭窗口
     */
    closeBrowserWin = () => {
        let {favouriteDialogStore, favouriteBrowserStore} = this.props;
        favouriteDialogStore.closeBrowserDialog();
    }

    /**
     * 保存数据
     * @param evt
     */
    submitBrowserWin = (evt) => {
        let {sysFavouriteStore, favouriteBrowserStore} = this.props;
        let {selectedKey} = favouriteBrowserStore;
        let {moveids} = sysFavouriteStore;
        moveids = mobx.toJS(moveids);
        if (!selectedKey) {   //没有选中目录
            Modal.error({
                content: `${getLabel(385877, "请选择一个目录！")}`
            });
        } else {
            sysFavouriteStore.moveToAnotherDir(moveids.join(), selectedKey);
        }
    }

  

    onRadioCheck = (checkedId) => {
        let {favouriteBrowserStore} = this.props;
        if (checkedId.indexOf("add") == -1 && checkedId.indexOf("edit") == -1) {    //非编辑状态下
            /**
             * 记录下选中的节点
             */
            favouriteBrowserStore.selectTreeNode(checkedId);
        }
    }

    componentDidUpdate() {
        /**
         * 默认选中文本框
         */
        for (let key in this.refs) {
            this.refs[key].focus();
            break;
        }
    }
    asyncLoad = (nodeid) =>{//这里可以优化
        let { favouriteBrowserStore} = this.props;
        function fn() {
            return new Promise((resolve, reject) => {
                resolve(favouriteBrowserStore.loadTreedata(nodeid)) //这是一个异步函数                                                           
            })
        } 
        let fn_1 = async function() {
            const data = await fn();//等待异步操作执行完了后执行的方法
            return new Promise((resolve)=>{ //loadData接口需要一个promise对象，所以这里要包装返回一个promise对象
                const data = {
                    datas: toJS(favouriteBrowserStore.testchildrendata)
                }
                resolve(data)
            })
        }
        return fn_1();   
    }
    render() {
        /**
         * 移动时，打开的收藏目录窗口信息
         */
        let {favouriteDialogStore, favouriteBrowserStore} = this.props;
        let visible = favouriteDialogStore.showBrowserDialog;
        let title = `${getLabel(388236, "收藏目录")}`;
        let style = {width: 620, height: 500};
        let buttons = [
            (<Button onClick={this.submitBrowserWin}>{getLabel('826','确定')}</Button>),
            (<Button onClick={this.closeBrowserWin}>{getLabel('31129','取消')}</Button>)
        ];
        let onCancel = this.closeBrowserWin;
        let params = {visible, title, style, buttons, onCancel};
        let {treeData, selectedKey, spinning, tip} = favouriteBrowserStore;
      
            return (
                <WeaDialog {...params}>
                    <Spin spinning={spinning} tip={tip} size="large">
                        <div className="favourite-browser-container">
                            <WeaScroll className="sysfav-scroll-wrapper" typeClass="scrollbar-macosx"
                                       style={{"width": "100%"}}>
                                <div className="favourite-browser-content">
                                   <WeaTree 
                                       hasRadio
                                       radioCheckedKey={favouriteBrowserStore.selectedKey}
                                       onRadioCheck={(id,radioCheckedKey) => {favouriteBrowserStore.selectedKey=radioCheckedKey}}
                                       datas={toJS(favouriteBrowserStore.testfatherdata)}
                                       loadData={(item) => {return this.asyncLoad(item.nodeid)}}
                                       
                                    ></WeaTree>
                                </div>
                            </WeaScroll>
                        </div>
                    </Spin>
                </WeaDialog>
            );
        }
    
}





// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/FavouriteBrowser.js